export default {
  'CHANGE_NEIGHBORHOODS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_NEIGHBORHOODS' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/neighborhoods/mutations.js